import bind from 'apmui/decorators/bind';
import * as React from 'react';
import {
    IOktaMfaModel,
    IVerifyEventModel,
    FIELD_TOTP,
    FIELD_PUSH,
    FIELD_SMS,
    FIELD_EMAIL,
    FIELD_MANUAL,
    ENROLL,
    UPDATE,
} from './Model';
import OktaVerify from './OktaVerify';
import Form from 'apmui/components/form/View';
import { IFormField, INPUT } from 'apmui/components/form/Model';
import { findField } from 'apmui/common/modelAPI';
import Input from 'apmui/components/form/Input';
import ProgressAnimation from 'apmui/components/ProgressAnimation';

interface ISmsEmailProps {
    okta: IOktaMfaModel;
    callback: (data: IVerifyEventModel) => void;
    disableBackBtn: () => void;
}

interface IPushEnrollState {
    enrollMethod: string | boolean;
    verify: boolean;
}

class SmsEmailOption extends React.Component<ISmsEmailProps, IPushEnrollState> {
    state = {
        enrollMethod: FIELD_SMS,
        verify: false,
    };

    @bind
    handleChange(name: string, value: string | boolean, event: Event) {
        if (value == FIELD_MANUAL) {
            const data: IVerifyEventModel = {
                factor: FIELD_TOTP,
                type: ENROLL,
            };
            this.props.callback(data);
        }
        const globalState = this.props.okta.oktaMfa.state;
        if (globalState.linkSent) {
            const data: IVerifyEventModel = {
                factor: 'linkSent',
                type: UPDATE,
                value: false,
            };
            this.props.callback(data);
        }
        this.setState({ enrollMethod: value });
    }

    @bind
    disableMoreOption() {
        const { state } = this.props.okta.oktaMfa;
        if (state.isMoreOption) {
            const data: IVerifyEventModel = {
                type: UPDATE,
                factor: 'isMoreOption',
                value: false,
            };
            this.props.callback(data);
        }
    }

    @bind
    onClick() {
        if (this.state.enrollMethod != FIELD_MANUAL) {
            const data: IVerifyEventModel = {
                factor: FIELD_PUSH,
                type: this.state.enrollMethod,
            };
            this.props.callback(data);
            if (this.state.enrollMethod == FIELD_EMAIL) {
                this.disableMoreOption();
            }
        } else {
            this.setState({ verify: true });
            this.props.disableBackBtn();
        }
    }

    @bind
    removeSmsField() {
        const { form } = this.props.okta.oktaMfa;
        const numberText = findField(form, FIELD_SMS);
        if (numberText) {
            for (let i = 0; i < form.fields.length; i++) {
                if (form.fields[i] == numberText) {
                    form.fields.splice(i, 1);
                }
            }
        }
    }

    componentDidMount() {
        const phoneNumberField = document.getElementsByName(FIELD_SMS)[0];
        if (phoneNumberField) {
            phoneNumberField.focus();
        }
    }

    render() {
        const { strings, form, state } = this.props.okta.oktaMfa;
        const globalState = this.props.okta.oktaMfa.state;
        let displayStyle;
        const styleObjBlock = { display: 'block' as 'block' };
        const styleObjNone = { display: 'none' as 'none' };
        if (!state.isMoreOption) {
            displayStyle = styleObjNone;
        } else {
            displayStyle = styleObjBlock;
        }
        const op = [
            { value: FIELD_SMS, text: strings.smsActivation },
            { value: FIELD_EMAIL, text: strings.emailActivation },
            { value: FIELD_MANUAL, text: strings.manualActivation },
        ];
        const inputSelect = (
            <div style={displayStyle}>
                <Input
                    type={INPUT.SELECT}
                    caption=""
                    name="options"
                    disabled={false}
                    options={op}
                    onChange={this.handleChange}
                />
            </div>
        );
        const donebutton = (
            <span style={displayStyle} className="button-container">
                <input
                    type="submit"
                    className="apmui-button apmui-button-submit apmui-button-long"
                    id="submit"
                    name="submit"
                    value={strings.next}
                    onClick={this.onClick}
                />
            </span>
        );
        let waitingAction = !state.isMoreOption && <ProgressAnimation />;
        let page = null;
        let activationField = null;
        switch (this.state.enrollMethod) {
            case FIELD_SMS: {
                const phoneNumber: IFormField = {
                    name: FIELD_SMS,
                    type: INPUT.TEL,
                    caption: strings.enterPhone,
                    disabled: false,
                    value: undefined,
                };
                const numberField = findField(form, FIELD_SMS);
                if (!numberField) {
                    form.fields.push(phoneNumber);
                }
                const smsForm = (
                    <div style={displayStyle}>
                        <Form {...form} />
                    </div>
                );
                activationField = smsForm;
                break;
            }
            case FIELD_MANUAL: {
                if (!globalState.hasEnrollInfo) {
                    activationField = <ProgressAnimation />;
                } else {
                    activationField = (
                        <div>
                            <p>{strings.oktaVerifyTotpSetup}</p>
                            <h3>{globalState.enrollInfo.secret}</h3>
                        </div>
                    );
                }
                break;
            }
        }
        page = (
            <div>
                {inputSelect}
                <br />
                {activationField}
                <br />
                {donebutton}
                <br />
            </div>
        );
        let linkSentDisplay = null;
        if (this.state.verify && this.state.enrollMethod == FIELD_MANUAL) {
            this.removeSmsField();
            waitingAction = <br />;
            page = <OktaVerify okta={this.props.okta} onClick={this.props.callback} />;
        } else if (globalState.linkSent && this.state.enrollMethod == FIELD_EMAIL) {
            linkSentDisplay = <p>{strings.linkSentEmail}</p>;
        } else if (globalState.linkSent && this.state.enrollMethod == FIELD_SMS) {
            linkSentDisplay = (
                <p>
                    {strings.linkSentSms}
                    {state.phoneNumber}
                </p>
            );
        }
        return (
            <div>
                {page}
                {waitingAction}
                {linkSentDisplay}
            </div>
        );
    }
}

export default SmsEmailOption;
